import type { GetLogReportDropdownItemsFn } from '@app/pages/CheckingPricesCompetitorsPage/types'

export const getLogReportDropdownItems: GetLogReportDropdownItemsFn = ({ onClickTechnicalItem, onClickPricesItem }) => {
  return [
    {
      key: 'technical-checks',
      label: 'Технические проверки',
      onClick: onClickTechnicalItem
    },
    {
      key: 'price-preparation',
      label: 'Подготовка цен',
      onClick: onClickPricesItem
    }
  ]
}
